import React, { FC } from 'react'
import { makeStyles, Box, BoxProps as MuiBoxProps } from 'transfix-ui/core'

const useActionListStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5),
    margin: 0,
  },
}))

interface IActionListProps {
  BoxProps?: MuiBoxProps
}

/**
 * Wrapper component which just adds spacing to <ActionListItem /> children
 */
export const ActionList: FC<IActionListProps> = ({ children, BoxProps = {} }) => {
  const classes = useActionListStyles()
  return (
    <Box component='ul' className={classes.root} {...BoxProps} data-test='action-list'>
      {children}
    </Box>
  )
}
